import Axios from 'axios';

var dateFormat = require('dateformat'); //formats dates very well

export function insertObjectIntoSorted(array, newItem, key) {
  var low = 0;
  var high = array.length;

  while (low < high) {
    var mid = (low + high) >>> 1; //integer division
    if (array[mid][key] < newItem[key]) low = mid + 1;
    else high = mid;
  }

  array.splice(low, 0, newItem);

  return array;
}

//https://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript
export function strToRGB(str = '') {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var c = ((hash * 100) & 0x00ffffff).toString(16).toUpperCase();

  return '#' + '00000'.substring(0, 6 - c.length) + c;
}

export function getRGBLightness(str) {
  var r,
    g,
    b = 0;
  r = parseInt('0x' + str.substring(1, 3));
  g = parseInt('0x' + str.substring(3, 5));
  b = parseInt('0x' + str.substring(5, 7));
  return (r + g + b) / 3;
}

export function strToCSSString(str, opacity) {
  var r,
    g,
    b = 0;
  r = parseInt('0x' + str.substring(1, 3));
  g = parseInt('0x' + str.substring(3, 5));
  b = parseInt('0x' + str.substring(5, 7));
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
}

export function isGUID(str) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
}

//https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
// Version 4.0
// percentage (+-1), color 0, color 1, true/false for linear/log blending
export const pSBC = (p, c0, c1, l) => {
  let r,
    g,
    b,
    P,
    f,
    t,
    h,
    i = parseInt,
    m = Math.round,
    a = typeof c1 == 'string';
  if (typeof p !== 'number' || p < -1 || p > 1 || typeof c0 !== 'string' || (c0[0] !== 'r' && c0[0] !== '#') || (c1 && !a)) return null;
  var pSBCr = (d) => {
    let n = d.length,
      x = {};
    if (n > 9) {
      [r, g, b, a] = d = d.split(',');
      n = d.length;
      if (n < 3 || n > 4) return null;
      x.r = i(r[3] === 'a' ? r.slice(5) : r.slice(4));
      x.g = i(g);
      x.b = i(b);
      x.a = a ? parseFloat(a) : -1;
    } else {
      if (n === 8 || n === 6 || n < 4) return null;
      if (n < 6) d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : '');
      d = i(d.slice(1), 16);
      if (n === 9 || n === 5) {
        // eslint-disable-next-line
        x.r = (d >> 24) & 255;
        // eslint-disable-next-line
        x.g = (d >> 16) & 255;
        // eslint-disable-next-line
        x.b = (d >> 8) & 255;
        x.a = m((d & 255) / 0.255) / 1000;
      } else {
        // eslint-disable-next-line
        x.r = d >> 16;
        // eslint-disable-next-line
        x.g = (d >> 8) & 255;
        // eslint-disable-next-line
        x.b = d & 255;
        x.a = -1;
      }
    }
    return x;
  };
  h = c0.length > 9;
  h = a ? (c1.length > 9 ? true : c1 === 'c' ? !h : false) : h;
  f = pSBCr(c0);
  P = p < 0;
  t = c1 && c1 !== 'c' ? pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 };
  p = P ? p * -1 : p;
  P = 1 - p;
  if (!f || !t) return null;
  if (l) {
    r = m(P * f.r + p * t.r);
    g = m(P * f.g + p * t.g);
    b = m(P * f.b + p * t.b);
  } else {
    r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5);
    g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5);
    b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
  }
  a = f.a;
  t = t.a;
  f = a >= 0 || t >= 0;
  a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0;
  if (h) return 'rgb' + (f ? 'a(' : '(') + r + ',' + g + ',' + b + (f ? ',' + m(a * 1000) / 1000 : '') + ')';
  else return '#' + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
};

export function toastError(toast, err) {
  if (!Axios.isCancel(err))
    toast.error(
      'Error: ' + err
        ? err?.response
          ? err.response.data
            ? err.response.data.message ?? err.response.data.Message ?? err.message ?? err.response.data
            : err?.response?.message ?? 'Undefined Error'
          : err?.message ?? err.toString() ?? 'Undefined Error'
        : 'Undefined Error',
      {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
}

export function toastSuccess(toast, msg, timeout = 5000) {
  toast.success(msg, {
    position: 'bottom-left',
    autoClose: timeout,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

export function getLocalDateString(date) {
  var dateParsed = new Date(Date.parse(date));
  return dateFormat(dateParsed, 'yyyy-mm-dd');
}

export function getUTCDateString(date, format) {
  if (date) {
    if (typeof date === 'string') {
      try {
        return dateFormat(date, format ?? 'yyyy-mm-dd', true);
      } catch {
        return '';
      }
    } else {
      return dateFormat(new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()), format ?? 'yyyy-mm-dd');
    }
  } else {
    return '';
  }
}

//This is used in agGrid or anything that need a data converted to American format
export function getUTCAmericanDateString(date) {
  if (date) {
    if (typeof date === 'string') {
      return dateFormat(date, 'yyyy-mm-dd', true);
    } else {
      return dateFormat(new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()), 'yyyy-mm-dd');
    }
  } else {
    return '';
  }
}

//https://stackoverflow.com/questions/563406/add-days-to-javascript-date
// eslint-disable-next-line
Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setUTCDate(date.getUTCDate() + days);
  return date;
};

//https://stackoverflow.com/questions/563406/add-days-to-javascript-date
// eslint-disable-next-line
export const addDays = function (date, days) {
  var newDate = new Date(date?.valueOf() ?? 0);
  newDate.setUTCDate((date?.getUTCDate() ?? 0) + days);
  return newDate;
};

export function unCamelCase(str) {
  return (
    str // insert a space before all single caps
      ?.replace(/([A-Z][a-z])/g, ' $1')
      // uppercase the first character
      ?.replace(/^./, function (str) {
        return str.toUpperCase();
      })
  );
}

/*
const useBetterCallback = (callback, values) => {
    const self = useRef({
        values: values,
        handler: (...args) => {
            return callback(...args, self.current.values)
        }
    });
    self.current.values = values
    return self.current.handler
}
*/
export function EmpitifyJson(toEmpty, emptyDefaults = { string: '', boolean: 'false', number: '0', undefined: '' }) {
  let data = toEmpty;
  let keys = Object.keys(data);
  keys.forEach((key) => {
    let type = typeof data[key];
    if (type === 'object') {
      //RECUSION
      data[key] = EmpitifyJson(data[key]);
    } else if (type) {
      data[key] = emptyDefaults[type];
    } else {
      data[key] = null;
    }
  });
  return data;
}

//http://blog.nicohaemhouts.com/2015/08/03/accessing-nested-javascript-objects-with-string-key/
export function getNested(theObject, path, separator = '.') {
  try {
    return path
      .replace('[', separator)
      .replace(']', '')
      .split(separator)
      .reduce((obj, property) => {
        return obj[property];
      }, theObject);
  } catch (err) {
    return undefined;
  }
}

//altered from above
export function setNested(theObject, newVal, path, separator = '.') {
  try {
    return path
      .replace('[', separator)
      .replace(']', '')
      .split(separator)
      .reduce((obj, property, i, src) => {
        if (i === src.length - 1) obj[property] = newVal;
        return obj[property];
      }, theObject);
  } catch (err) {
    return undefined;
  }
}
